import { Dispatch } from 'redux';
import Service from 'src/setup/network';
import { Currency } from 'src/types/model';
import { CurrencyActionType, FETCH_CURRENCY_FAILURE, FETCH_CURRENCY_REQUEST, FETCH_CURRENCY_SUCCESS, FETCH_MY_CURRENCY_SUCCESS } from '../types/currencyType';

export const fetchCurrenciesRequest = (): CurrencyActionType => ({
  type: FETCH_CURRENCY_REQUEST,
});

export const fetchCurrenciesSuccess = (data: Currency[]): CurrencyActionType => ({
  type: FETCH_CURRENCY_SUCCESS,
  payload: data,
});

export const fetchMyCurrencySuccess = (data: Currency): CurrencyActionType => ({
  type: FETCH_MY_CURRENCY_SUCCESS,
  payload: data,
});

export const fetchCurrenciesFailure = (error: string): CurrencyActionType => ({
  type: FETCH_CURRENCY_FAILURE,
  payload: error,
});

export const fetchCurrenices = () => {
  return async (dispatch: Dispatch<CurrencyActionType>) => {
    dispatch(fetchCurrenciesRequest());
    try {
      const request = await Service.get('/settings/currencies');
      const data: Currency [] = await request?.data?.data?.currencies;
      dispatch(fetchCurrenciesSuccess(data));
    } catch (error: any) {
      dispatch(fetchCurrenciesFailure(error?.response?.data?.message));
      throw new Error('Failed to fetch currency');
    }
  };
};

export const fetchMyCurrency = () => {
  return async (dispatch: Dispatch<CurrencyActionType>) => {
    dispatch(fetchCurrenciesRequest());
    try {
      const request = await Service.get('/settings/currency');
      const data: Currency = await request?.data?.data?.currency;
      dispatch(fetchMyCurrencySuccess(data));
    } catch (error: any) {
      dispatch(fetchCurrenciesFailure(error?.response?.data?.message));
      throw new Error('Failed to fetch currency');
    }
  };
};
